export default {
  hubTitle: 'TicketHub.title',
  hubSubtitle: 'TicketHub.subtitle',
  defaultFilterLabel: 'TicketHub.Filters.inputPlaceHolder',
  checkBoxFilterLabel: 'TicketHub.Filters.assignedToMe',
  ticketListTitle: 'TicketHub.TicketList.title',
  statusClosed: 'TicketHub.TicketList.item.statusClosed',
  statusOpen: 'TicketHub.TicketList.item.statusOpen',
  statusAssigned: 'TicketHub.TicketList.item.statusAssigned',
  statusReopened: 'TicketHub.TicketList.item.statusReopened',
  statusReassigned: 'TicketHub.TicketList.item.statusReassigned',
  itemRouteLabel: 'TicketHub.TicketList.item.route',
  itemStopLabel: 'TicketHub.TicketList.item.stop',
  itemAttendendByLabel: 'TicketHub.TicketList.item.attendendBy',
  itemButtonAccept: 'TicketHub.TicketList.item.buttonAccept',
  itemButtonReAssign: 'TicketHub.TicketList.item.buttonReassign',
  dataNotFound: 'TicketHub.TicketList.dataNotFound',
  itemButtonViewTicket: 'TicketHub.TicketList.item.buttonViewTicket'
};
